import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/avatar.jpg'


const _withScopeId = n => (_pushScopeId("data-v-51418c1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-bg" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, " LI XIN CHENG ", -1))
const _hoisted_3 = { class: "menu" }
const _hoisted_4 = { class: "flex app-layout-head" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "user-avatar",
  src: _imports_0
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  DownOutlined,
} from "@ant-design/icons-vue";
import zhCN from 'ant-design-vue/es/locale/zh_CN';
  import dayjs from 'dayjs';
  import 'dayjs/locale/zh-cn';
  import { useStore } from "vuex";
import { defineComponent, ref, watch, computed, onMounted } from "vue";
import AliIcon from "@/components/Ali-Icon.vue";
import { getCookie } from "@/utils/support";
import { Menu, MenuItem, Dropdown, Space } from "ant-design-vue";
import TabBar from "./Tabbar.vue";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutIndex',
  setup(__props) {

dayjs.locale('zh-cn');
const locale = computed(() => {
  return zhCN;
});
const route = useRoute();
const store = useStore();
const theme = ref<boolean>(true);
const menuTheme = ref<boolean>(true);

const selectedKeys = ref<string[]>(["1"]);
const openKeys = ref<string[]>([]);
const collapsed = ref<boolean>(false);
const avatar = store.getters.avatar;
const username = getCookie("usernameAdmin");
//更换主题
const changeTheme = () => {
  theme.value = !theme.value;
  menuTheme.value = !menuTheme.value;
};
const hasOneShowingChildren = (children: any) => {
  const showingChildren = children.filter((item: any) => {
    return !item.hidden;
  });
  if (showingChildren.length === 1) {
    return true;
  }
  return false;
};
//登出
const logout = () => {
  store.dispatch("LogOut").then(() => {
    location.reload(); // 为了重新实例化vue-router对象 避免bug
  });
};
// 使用 computed 创建计算属性
const routes = computed(() => {
  return store.getters.routers;
});
const isCollapse = computed(() => {
  return !store.getters.sidebar.opened;
});

onMounted(() => {
  openKeys.value = [route.path.split("/")[1]];
  selectedKeys.value = [route.path];
});
watch(route, (value) => {
  openKeys.value = [route.path.split("/")[1]];
  selectedKeys.value = [route.path];
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: locale.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              (collapsed.value)
                ? (_openBlock(), _createBlock(_unref(MenuUnfoldOutlined), {
                    key: 0,
                    class: "trigger",
                    onClick: _cache[0] || (_cache[0] = () => (collapsed.value = !collapsed.value))
                  }))
                : (_openBlock(), _createBlock(_unref(MenuFoldOutlined), {
                    key: 1,
                    class: "trigger",
                    onClick: _cache[1] || (_cache[1] = () => (collapsed.value = !collapsed.value))
                  }))
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Space), {
              wrap: "",
              style: {"margin-right":"12px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { onClick: changeTheme }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(menuTheme.value ? "light" : "dark"), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(Dropdown), null, {
              overlay: _withCtx(() => [
                _createVNode(_component_a_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_menu_item, null, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_menu_item, null, {
                      default: _withCtx(() => [
                        _createElementVNode("a", { onClick: logout }, "退出")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "avatar",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
                }, [
                  (_unref(avatar))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "user-avatar",
                        src: _unref(avatar)
                      }, null, 8, _hoisted_5))
                    : (_openBlock(), _createElementBlock("img", _hoisted_6)),
                  _createElementVNode("span", null, _toDisplayString(_unref(username)), 1)
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_a_layout, { class: "app-layout" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_layout_sider, {
              class: "app-layout-sider",
              collapsed: collapsed.value,
              "onUpdate:collapsed": _cache[6] || (_cache[6] = ($event: any) => ((collapsed).value = $event)),
              trigger: null,
              collapsible: "",
              style: _normalizeStyle(
          menuTheme.value ? 'background:rgba(255,255,255)' : 'background: black;'
        )
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu, {
                  selectedKeys: selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[3] || (_cache[3] = ($event: any) => ((selectedKeys).value = $event)),
                  openKeys: openKeys.value,
                  "onUpdate:openKeys": _cache[4] || (_cache[4] = ($event: any) => ((openKeys).value = $event)),
                  theme: menuTheme.value ? 'light' : 'dark',
                  mode: "inline",
                  collapsed: isCollapse.value,
                  "onUpdate:collapsed": _cache[5] || (_cache[5] = ($event: any) => ((isCollapse).value = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routes.value, (item, i) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                        (!item.hidden && item.children)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              (
                  hasOneShowingChildren(item.children) &&
                  !item.children[0].children &&
                  !item.alwaysShow
                )
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: item.path + '/' + item.children[0].path
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_menu_item, {
                                        index: item.path + '/' + item.children[0].path,
                                        class: _normalizeClass({ 'submenu-title-noDropdown': true })
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(AliIcon, {
                                            iconName: item.children[0].meta.icon
                                          }, null, 8, ["iconName"]),
                                          (item.children[0].meta && item.children[0].meta.title)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.children[0].meta.title), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["index"])
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createBlock(_component_a_sub_menu, {
                                    key: item.name || item.path
                                  }, {
                                    title: _withCtx(() => [
                                      _createVNode(AliIcon, {
                                        iconName: item.meta.icon
                                      }, null, 8, ["iconName"]),
                                      (item.meta && item.meta.title)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                            _createElementVNode("span", null, _toDisplayString(item.meta.title), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, c) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, { key: c }, [
                                          (!child.hidden)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                (child.children && child.children.length > 0)
                                                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                                      "is-nest": true,
                                                      class: "nest-menu",
                                                      routes: [child],
                                                      key: child.path
                                                    }, null, 8, ["routes"]))
                                                  : (_openBlock(), _createBlock(_component_router_link, {
                                                      to: item.path + '/' + child.path,
                                                      key: child.name
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(), _createBlock(_component_a_menu_item, {
                                                          key: item.path + '/' + child.path
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(AliIcon, {
                                                              iconName: child.meta.icon
                                                            }, null, 8, ["iconName"]),
                                                            (child.meta && child.meta.title)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(child.meta.title), 1))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["to"]))
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_13))
                                        ], 64))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["selectedKeys", "openKeys", "theme", "collapsed"])
              ]),
              _: 1
            }, 8, ["collapsed", "style"]),
            _createVNode(_component_a_layout, null, {
              default: _withCtx(() => [
                _createVNode(TabBar),
                _createVNode(_component_a_layout_content, { class: "app-layout-content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})